import { cn } from "../../utils/classnames.js";
import { DropdownMenuBackdrop } from "../atoms/dropdown-menu.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { CheckIcon, ChevronRightIcon } from "lucide-react";
import { Menu as Menu$1 } from "@base-ui/react/menu";
//#region src/components/molecules/dropdown-menu.tsx
const DropdownMenuContent = ({ className, align = "start", alignOffset = 0, keepPortalMounted = true, side = "bottom", sideOffset = 4, ...props }) => {
	return /* @__PURE__ */ jsxs(Menu$1.Portal, {
		keepMounted: keepPortalMounted,
		children: [/* @__PURE__ */ jsx(DropdownMenuBackdrop, {}), /* @__PURE__ */ jsx(Menu$1.Positioner, {
			className: "isolate z-50 outline-none",
			align,
			alignOffset,
			side,
			sideOffset,
			children: /* @__PURE__ */ jsx(Menu$1.Popup, {
				"data-slot": "dropdown-menu-content",
				className: cn(`
              bg-popover text-popover-foreground
              data-closed:fade-out-0
              data-open:fade-in-0
              data-closed:zoom-out-95
              data-open:zoom-in-95
              data-[side=bottom]:slide-in-from-top-2
              data-[side=left]:slide-in-from-right-2
              data-[side=right]:slide-in-from-left-2
              data-[side=top]:slide-in-from-bottom-2
              rounded-md p-2 shadow-md
              data-open:animate-in
              data-closed:animate-out
              z-50 max-h-[--available-height] min-w-[8rem] origin-[--transform-origin]
              overflow-x-hidden overflow-y-auto border
            `, className),
				...props
			})
		})]
	});
};
const DropdownMenuCheckboxItem = ({ className, children, checked, ...props }) => {
	return /* @__PURE__ */ jsxs(Menu$1.CheckboxItem, {
		"data-slot": "dropdown-menu-checkbox-item",
		className: cn(`
          focus:bg-accent focus:text-accent-foreground
          gap-2 rounded-sm py-1.5 pr-2 pl-8 text-sm
          [&_svg:not-[class*='size-']]:size-4
          relative flex cursor-default items-center outline-hidden select-none
          data-disabled:pointer-events-none data-disabled:opacity-50
          [&_svg]:pointer-events-none [&_svg]:shrink-0
        `, className),
		checked,
		...props,
		children: [/* @__PURE__ */ jsx("span", {
			className: "left-2 size-3.5 pointer-events-none absolute flex items-center justify-center",
			children: /* @__PURE__ */ jsx(Menu$1.CheckboxItemIndicator, { children: /* @__PURE__ */ jsx(CheckIcon, { className: "size-4" }) })
		}), children]
	});
};
const DropdownMenuRadioItem = ({ className, children, ...props }) => {
	return /* @__PURE__ */ jsxs(Menu$1.RadioItem, {
		"data-slot": "dropdown-menu-radio-item",
		className: cn(`
          focus:bg-accent focus:text-accent-foreground
          gap-2 rounded-sm py-1.5 pr-2 pl-8 text-sm
          [&_svg:not-[class*='size-']]:size-4
          relative flex cursor-default items-center outline-hidden select-none
          data-disabled:pointer-events-none data-disabled:opacity-50
          [&_svg]:pointer-events-none [&_svg]:shrink-0
        `, className),
		...props,
		children: [/* @__PURE__ */ jsx("span", {
			className: "left-2 size-3.5 pointer-events-none absolute flex items-center justify-center",
			children: /* @__PURE__ */ jsx(Menu$1.RadioItemIndicator, { children: /* @__PURE__ */ jsx(CheckIcon, { className: "size-4" }) })
		}), children]
	});
};
const DropdownMenuSubTrigger = ({ className, inset, children, ...props }) => {
	return /* @__PURE__ */ jsxs(Menu$1.SubmenuTrigger, {
		"data-slot": "dropdown-menu-sub-trigger",
		"data-inset": inset,
		className: cn(`
          focus:bg-accent
          hover:bg-accent
          data-popup-open:bg-accent data-popup-open:text-accent-foreground
          data-open:bg-accent data-open:text-accent-foreground
          [&_svg:not-[class*='text-']]:text-muted-foreground
          gap-2 rounded-sm px-2 py-1.5 text-sm
          data-[inset]:pl-8
          [&_svg:not-[class*='size-']]:size-4
          flex cursor-default items-center outline-hidden select-none
          [&_svg]:pointer-events-none [&_svg]:shrink-0
        `, className),
		...props,
		children: [children, /* @__PURE__ */ jsx(ChevronRightIcon, { className: "size-4 ml-auto" })]
	});
};
const DropdownMenuSubContent = ({ className, align = "start", alignOffset = -3, side = "right", sideOffset = 0, ...props }) => {
	return /* @__PURE__ */ jsx(DropdownMenuContent, {
		"data-slot": "dropdown-menu-sub-content",
		className: cn(`
          rounded-md bg-popover p-1 text-popover-foreground shadow-lg ring-foreground/10 w-auto
          min-w-[96px] ring-1
        `, className),
		align,
		alignOffset,
		side,
		sideOffset,
		...props
	});
};
//#endregion
export { DropdownMenuCheckboxItem, DropdownMenuContent, DropdownMenuRadioItem, DropdownMenuSubContent, DropdownMenuSubTrigger };

//# sourceMappingURL=dropdown-menu.js.map